import React from 'react';
import { useSelector } from 'react-redux';

import { convertAmount } from '../../../../utils/formatters';
import { RootState } from '../../redux/store';

import MobileQuickPickButton from './MobileQuickPickButton';

function MobileQuickPickAll() {
    const { lottery, currencyCode } = useSelector((state: RootState) => state.playStore);

    const getLinesPrice = (count: number) => convertAmount(lottery.lotteryRule.line_sell_price * count, currencyCode);

    const quickPickOptions = lottery.slug.includes('mini') ? [10, 20] : [3, 6];

    return (
        <>
            {quickPickOptions.map((lines) => (
                <MobileQuickPickButton key={lines} linesPrice={getLinesPrice(lines)} quickPickLines={lines} />
            ))}
        </>
    );
}

export default MobileQuickPickAll;
